export const TOOLTIP_COPY = {
  DIRECT_API: `Total funds available for consumption for WhatsApp per-message charges and per WABA. This balance is deducted in real time for messaging and monthly per WABA charges.`,

  WHITELABEL: `Funds allocated specifically to your Whitelabel platform. This balance is used to facilitate transactions for your downstream sub-users, including WhatsApp messages, plan subscriptions (including upgrades or downgrades), Meta ads credits, renewals, partnership renewals, and WhatsApp Payments.`,

  MIN_BALANCE: `The mandatory minimum threshold required to keep your services active. If your balance falls below this amount, API calls or transactions may be restricted.`,

  ARCHIVED: `Projects that are no longer active and have been deleted by the Partner. Archived data cannot be edited or reactivated.`,

  DRAFT: `The configuration is currently under development. It is not visible to end users, and no live transactions can be processed.`,

  LIVE: `The configuration is active and public. Transactions and API calls are currently being processed in the production environment.`,
};
